import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import getConfig from "next/config"

const { publicRuntimeConfig } = getConfig()

/**
 * Resolves the Bugsnag API key for the current runtime environment.
 * Server-side: reads from the Kubernetes secret via `k8sSecrets.server` (requires `fs`).
 * Client-side: reads from `publicRuntimeConfig` (injected at build time).
 *
 * The dynamic `require` keeps `fs` out of the client bundle — webpack dead-code-eliminates
 * the server branch when `typeof window !== "undefined"`.
 */
function resolveApiKey(): string | undefined {
  if (typeof window === "undefined") {
    // Dynamic require keeps fs out of the client bundle (webpack dead-code-eliminates this branch)
    const { serverBugsnagApiKey } = require("../../k8sSecrets.server")
    return serverBugsnagApiKey()
  }
  return publicRuntimeConfig.BUGSNAG_API_KEY
}

const apiKey = resolveApiKey()

if (apiKey) {
  Bugsnag.start({
    apiKey,
    appVersion: publicRuntimeConfig.GIT_COMMIT,
    releaseStage: publicRuntimeConfig.APP_ENV,
    enabledReleaseStages: ["staging", "production"],
    collectUserIp: false,
    plugins: [new BugsnagPluginReact()],
  })
}

export { Bugsnag }
